import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";
import {handleError} from "../../../helpers/handleError";

const saveProjectReport = {
    namespaced: true,
    state: {
        dataSaveIsFetching: false,
        textInfoTimeReportSave: "",
        typeInfoTimeReportSave: "",
        headInfoTimeReportSave: "",
        isTimeReportSave: false,
        dataStoreAndSaveIsFetching: false,
        isModalSendTimeReportVisible: false,
        timeReport: null,
    },
    mutations: {
        DATA_SAVE_REQUEST(state, value) {
            state.dataSaveIsFetching = value;
        },
        DATA_STORE_AND_SAVE_REQUEST(state, value) {
            state.dataStoreAndSaveIsFetching = value;
        },
        DATA_SAVE_SUCCESS(state, response) {
            state.typeInfoTimeReportSave = "green";
            state.headInfoTimeReportSave = response.data.message;
            state.textInfoTimeReportSave = response.data.data.textInfo;
            state.isTimeReportSave = true
            state.dataSaveIsFetching = false;
            eventBus.$emit("saveTimeReportSuccess", response.data.data.timeReport);
            eventBus.$emit('saveTimeReportPDFSuccess', response.data);          
        },
        DATA_SAVE_FAILURE(state, error) {
            state.dataSaveIsFetching = false;
            if (error.response.data.errors.type && error.response.data.errors.type[0] === 'diskLimitExceeded') {
                eventBus.$emit('projectDiskLimitExceeded', error.response.data.errors);
            } else {
                state.textInfoTimeReportSave = handleError(error) !== "" ? handleError(error) : error.response.data.data.message;
                state.typeInfoTimeReportSave = "red";
                state.headInfoTimeReportSave = error.response.data.message;
                state.isTimeReportSave = true;
                eventBus.$emit("saveTimeReportFailure", error.response.data.errors);
            }      
        },
        DATA_SAVE_AND_SEND_SUCCESS(state, response) {
            state.dataStoreAndSaveIsFetching = false;
            state.isModalSendTimeReportVisible = true;
            state.timeReport = response.data.data.timeReport;
            eventBus.$emit("saveTimeReportSuccess", response.data.data.timeReport);
            eventBus.$emit('saveTimeReportPDFSuccess', response.data);
        },
        DATA_SAVE_AND_SEND_FAILURE(state, error) {
            state.dataStoreAndSaveIsFetching = false;
            if (error.response.data.errors.type && error.response.data.errors.type[0] === 'diskLimitExceeded') {
                eventBus.$emit('projectDiskLimitExceeded', error.response.data.errors);
            } else {
                state.textInfoTimeReportSave = handleError(error) !== "" ? handleError(error) : error.response.data.data.message;
                state.typeInfoTimeReportSave = "red";
                state.headInfoTimeReportSave = error.response.data.message;
                state.isTimeReportSave = true;         
            }       
            // eventBus.$emit("saveTimeReportFailure", error.response.data.errors);
        },
        UPDATE_VISIBLE_MODAL(state, value) {
            state.isTimeReportSave = value;
        },
        HIDE_MODAL_SEND_TIME_REPORT(state, value) {
            state.isModalSendTimeReportVisible = value;
        }
    },
    actions: {
        storeProjectReport: function({ dispatch }, payload) {
            dispatch("requestDataSave", true);
            let promise = sendRequest("post", config.baseURLApi + "/timereports", {}, payload.creds);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successDataSave", result[1]);
                } else {
                    dispatch("failureDataSave", result[1]);
                }
            });
        },
        storeAndSendProjectReport: function({ dispatch }, payload) {
            dispatch("requestStoreAndSend", true);
            let promise = sendRequest("post", config.baseURLApi + "/timereports", {}, payload.creds);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successDataSaveAndSend", result[1]);
                } else {
                    dispatch("failureDataSaveAndSend", result[1]);
                }
            });
        },
        requestDataSave: function({ commit }, value) {
            commit("DATA_SAVE_REQUEST", value);
        },
        requestStoreAndSend: function({ commit }, value) {
            commit("DATA_STORE_AND_SAVE_REQUEST", value);
        },
        successDataSave: function({ commit }, response) {
            commit("DATA_SAVE_SUCCESS", response);
        },
        failureDataSave: function({ commit }, error) {
            commit("DATA_SAVE_FAILURE", error);
        },
        successDataSaveAndSend: function({ commit }, response) {
            commit("DATA_SAVE_AND_SEND_SUCCESS", response);
        },
        failureDataSaveAndSend: function({ commit }, error) {
            commit("DATA_SAVE_AND_SEND_FAILURE", error);
        },
        updateVisibleModal: function({ commit }, value) {
            commit("UPDATE_VISIBLE_MODAL", value);
        },
        hideModalSendTimeReport: function({ commit }, value) {
            commit("HIDE_MODAL_SEND_TIME_REPORT", value)
        }
    }
}

export default saveProjectReport;